const STORAGE_KEY = 'casualer.termsNoticeSeenVersion';

export const initTermsNotice = (
    documentRef = document,
    windowRef = window,
) => {
    const state = windowRef.__AUTH_STATE__?.termsNotice;
    const notice = documentRef.querySelector('[data-terms-notice]');
    const version = String(state?.version ?? '').trim();
    if (version === '' || !(notice instanceof HTMLElement)) {
        return false;
    }

    try {
        if (windowRef.localStorage.getItem(STORAGE_KEY) === version) {
            return false;
        }

        windowRef.localStorage.setItem(STORAGE_KEY, version);
    } catch {
        // Storage can be unavailable in privacy modes; showing the notice is the safe fallback.
    }

    notice.hidden = false;
    const closeButton = notice.querySelector('[data-terms-notice-close]');
    closeButton?.addEventListener('click', () => {
        notice.hidden = true;
    });

    return true;
};
